import store from '@/store'

export default [
  {
    path: '/promotions',
    name: 'promotion',
    meta: { requiresAuth: true },
    component: () => import('@/pages/promotion/form.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('promotion/dataBeforeCreate')
      next()
    }
  },
  {
    path: '/promotions/:id',
    name: 'promotion-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/promotion/form.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('promotion/find', to.params.id)
      await store.dispatch('promotion/dataBeforeCreate')
      next()
    }
  }
]
